import { Country } from '@abiglobalhealth/go-types'

import i18n from '@/locale/i18n'

const EMERGENCY_NUMBERS: Record<Country['code'], string[]> = {
  ie: ['112', '999']
}

const getEmergencyPhoneNumber = (country: Country): string[] | undefined => EMERGENCY_NUMBERS[country.code]

const getEmergencyNumberLinks = (country: Country): string | null => {
  const numbers = getEmergencyPhoneNumber(country)
  if (!numbers) return null

  return numbers.map((number) => `<a href="tel:${number}">${number}</a>`).join(' / ')
}

export const getEmergencyNumberTranslation = (country: Country): string => {
  const numbers = getEmergencyPhoneNumber(country)
  if (!numbers) return i18n.t('general.consultation.mentalHealthEvaluation.disclaimer.suicide_thoughts.fallback')

  return i18n.t('general.consultation.mentalHealthEvaluation.disclaimer.suicide_thoughts', {
    interpolation: {
      escapeValue: false
    },
    emergencyPhoneNumber: getEmergencyNumberLinks(country)
  })
}
